module.exports = __webpack_public_path__ + "static/media/Orange_Button@2x.932cb886.png";